/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rights_Drawer_Inherit_GrantedInputs */



/**
* | output |
* | --- |
* | "Falls back to the organization default: granted." |
*
* @param {Rights_Drawer_Inherit_GrantedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_drawer_inherit_granted = /** @type {((inputs?: Rights_Drawer_Inherit_GrantedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Drawer_Inherit_GrantedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Fällt auf den Org-Standard zurück: gewährt.")
	return /** @type {LocalizedString} */ ("Falls back to the organization default: granted.")
});